import LoadingSpinner from '@/components/Loaders/LoadingSpinner.vue';
import { defineComponent } from '@vue/composition-api';
import { checkboxProps } from '@/components/Inputs/Checkbox/checkbox.constants';
export default defineComponent({
    components: { LoadingSpinner },
    props: checkboxProps,
});
